import { useSecureGraphqlQuery } from '@psyomics/ui-common';
import { type ArticleContent, toArticleContent } from '@psyomics/ui-components';
import { AnyVariables } from 'urql';

import { ArticleByCmsSystemIdDocument, ArticleByCmsSystemIdQuery } from '../generated/professional-referral';

const useCmsArticle = (
  cmsSystemId?: string
): { article: ArticleContent | null; fetching: boolean; errorMessage?: 'ContentNotFound' } => {
  const [{ data, fetching, errorMessage }] = useSecureGraphqlQuery<
    ArticleByCmsSystemIdQuery,
    AnyVariables,
    'ContentNotFound'
  >(
    {
      pause: !cmsSystemId,
      query: ArticleByCmsSystemIdDocument,
      variables: { cmsSystemId },
    },
    ['ContentNotFound']
  );

  const article = toArticleContent(data?.articleByCmsSystemId);

  return { article, fetching, errorMessage };
};

export { useCmsArticle };
